export default __webpack_public_path__ + "static/media/ic_close.017c7931.svg";